import ForwardToInboxIcon from "@/components/ui/icon/forward-to-inbox";

import { Island } from "../_components/island";

export const AuthVerifyYourEmail = () => {
	return (
		<Island>
			<div className="flex items-center gap-x-2">
				<ForwardToInboxIcon size="md" />
			</div>

			<div className="text-gray-900 text-md space-y-0.5 leading-tight tracking-tight">
				<p>認証メールを送信しました</p>
				<p>メールボックスをご確認ください</p>
			</div>
		</Island>
	);
};
